import { Component, OnInit } from "@angular/core";
import { Constants } from "../Services/Constants";
import { HTTPService } from "../Services/http.service";
import { Observable } from "rxjs/Observable";
import { filter } from "../App/search.pipe";
import { MySharedService } from "../App/shared.service";
declare function ExportToExcel(
  item: any[],
  workSheetName: string,
  keys: any,
  Columns?: any,
): void;

@Component({
  templateUrl: "./AppViews/MyTask/myTask.html",
})
export class MyTaskComponent implements OnInit {
  userDetail: any;
  public constants: Constants;
  public myTask: any[];
  public taskGroupList: any[];
  public filterTaskTypeStatus: any = "";
  public filterTasktype: any = "";
  public taskType: any[];
  public filter: any = {
    ProjectId: "",
    AssignedTo: "",
    TaskOwner: "",
    CreatedBy: "",
    Status: "",
    ProjectTypeId: "",
    isOpenTask: true,
    Search: "",
  };
  public isAdd: boolean = true;
  active = true;
  public showLoader = false;
  public isFormSubmitted: boolean = false;
  public projectList: any[];
  public filterFlag: any;
  public usersItems: any[];
  public StatusItems: any[] = [];
  public allStatusItems: any[] = [];
  public projectTypeItems: any = [];
  public filterLS: any = [];
  addTimeSheetData: any = {
    ProjectId: "",
    UserId: "",
    TaskTypeId: "",
    TimeSpent: "",
    Comments: "",
    TimeSheet_Date: moment(new Date()).format("DD/MM/YYYY"),
    Created_By: "",
    TaskId: "",
  };
  public TaskList: any[] = [];
  constructor(
    private _httpService: HTTPService,
    private _sharedService: MySharedService,
  ) {
    this.constants = new Constants();
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));

    // this.filterLS = JSON.parse(localStorage.getItem("TaskFilters"));

    // if (this.filterLS) {
    //   this.filter = this.filterLS;
    // } else {
    //   this.filter = this.getDefaultFilter();
    //   localStorage.setItem("TaskFilters", JSON.stringify(this.filter));
    // }

    const storedFilters = JSON.parse(
      localStorage.getItem("TaskFilters") || "{}",
    );

    this.filter = { ...this.getDefaultFilter(), ...storedFilters };
    localStorage.setItem("TaskFilters", JSON.stringify(this.filter));

    this.filterLS = this.filter;
  }

  newForm() {
    this.active = false;
    setTimeout(() => (this.active = true), 0);
  }

  ngOnInit() {
    this.getStatus();
    this.getProjectType();
    this.GetProjectList();
    this.getUsers(0);
    this.getMyTask();
  }

  ngAfterViewInit() {
    $("#show-filter").click(function () {
      $(".filter-form").slideToggle();
    });

    $(".date").datetimepicker({
      format: "DD/MM/YYYY",
      maxDate: moment(),
    });
  }

  public getDefaultFilter() {
    return {
      ProjectId: "",
      AssignedTo: this.userDetail.SiteUserId,
      TaskOwner: "",
      CreatedBy: "",
      isOpenTask: true,
      Search: "",
      Status: "",
      ProjectTypeId: "",
    };
  }

  public AddTeamFormLoad() {
    $("#btnAddTeamForm").trigger("click");
  }

  public ResetForm(form: any) {
    form.reset();
    form.resetForm();
    this.isFormSubmitted = false;
  }

  public clearFilter() {
    this.filter = this.getDefaultFilter();

    localStorage.setItem("TaskFilters", JSON.stringify(this.filter));

    this.filterStatus(true);
    this.getUsers(0);
    this.getMyTask();
  }

  setFilters() {
    localStorage.setItem("TaskFilters", JSON.stringify(this.filter));
    this.getMyTask();
  }

  GetProjectList() {
    this._httpService
      .ajaxPost("Project/GetProjectsByUserWithTasks", {
        ProjectTypeId: this.filter.ProjectTypeId,
        TaskStatus: this.filter.Status,
        IsOpenTask: this.filter.isOpenTask,
        UserId: this.userDetail.SiteUserId,
      })
      .subscribe(
        (data) => {
          this.projectList = data["ProjectList"];
          this.filter.ProjectId = "";
        },
        (err) => {
          console.log("GetProjectList Failed");
        },
        () => {},
      );
  }

  public getUsers(projectid) {
    this._httpService
      .ajaxPost("TimeSheet/GetUsersByProject", {
        Project_Id: projectid || 0,
        IsActive: this.constants.enumUserStatus["Active"],
        Team_Id: "0",
        ProjectType: 0,
        Status: 1,
        UserId: 0,
      })
      .subscribe((data) => {
        this.usersItems = data["Users"];
      });
  }

  public getMyTask() {
    this.showLoader = true;
    // if (this.userDetail.RoleId == this.constants.enumUserRole.Executive) {
    //   this.filter.AssignedTo = this.userDetail.SiteUserId;
    // }
    this._httpService
      .ajaxPost("MyTask/GetAllTask", {
        ProjectId: this.filter.ProjectId || 0,
        AssignedTo: this.filter.AssignedTo || 0,
        TaskOwner: this.filter.TaskOwner || 0,
        CreatedBy: 0,
        LoggedInUser: this.userDetail.SiteUserId || 0,
        Status: this.filter.Status || 0,
        ProjectTypeId: this.filter.ProjectTypeId || 0,
        isOpenTask: this.filter.isOpenTask,
      })
      .subscribe(
        (data) => {
          this.myTask = data["MyTask"];
        },
        (err) => {
          this.showLoader = false;
          this._sharedService.ShowMessage(this.constants.globalError);
        },
        () => {
          this.showLoader = false;
        },
      );
  }

  GetTaskList(val) {
    if (val == "") {
      this.TaskList = [];
    } else {
      this.showLoader = true;
      this._httpService
        .ajaxPost("TaskType/GetTaskTypeByProjectId", { ProjectId: val })
        .subscribe(
          (data) => {
            this.TaskList = data["TaskTypeList"];
          },
          (err) => {
            this.showLoader = false;
          },
          () => {
            this.showLoader = false;
          },
        );
    }
  }

  SaveTask(TaskId, ProjectId, TaskName) {
    localStorage.setItem(
      "TimesheetTask",
      JSON.stringify({
        TaskId: TaskId,
        ProjectId: ProjectId,
        TaskName: TaskName,
      }),
    );
    this.addTimeSheetData.Comments = TaskName;
    this.GetTaskList(ProjectId);
  }

  public getStatus() {
    this._httpService
      .ajaxPost("Common/GetParameter", {
        ParameterTypeId: this.constants.enumParamterTypeName["TaskStatusType"],
      })
      .subscribe((data) => {
        this.StatusItems = data["Parameter"];

        this.allStatusItems = [...this.StatusItems];
        if (this.filter.isOpenTask) {
          this.filterStatus(true);
        } else {
          this.filterStatus(false);
        }
      });
  }

  public getProjectType() {
    this._httpService
      .ajaxPost("Common/GetParameter", {
        ParameterTypeId: this.constants.enumParamterTypeName["ProjectType"],
      })
      .subscribe((data) => {
        this.projectTypeItems = data["Parameter"];
      });
  }

  filterStatus(isOpen: boolean) {
    this.filter.Status = "";
    const openStatuses = ["2", "3", "5", "4"];
    const closedStatuses = ["6", "7"];
    const allowed = isOpen ? openStatuses : closedStatuses;
    this.StatusItems = this.allStatusItems.filter((s) =>
      allowed.includes(s.Value),
    );

    this.GetProjectList();
  }

  public CancelAddTimesheet() {
    this.addTimeSheetData = {
      ProjectId: "",
      UserId: "",
      TaskTypeId: "",
      TimeSpent: "",
      Comments: "",
      TimeSheet_Date: moment(new Date()).format("DD/MM/YYYY"),
      Created_By: "",
      TaskId: "",
    };

    $("#addTimesheet").modal("hide");
  }

  addTimesheetTask() {
    if (this.validate(this.addTimeSheetData)) {
      var TimesheetTask = JSON.parse(localStorage.getItem("TimesheetTask"));

      if (!TimesheetTask) return;

      var model = {
        ProjectId: TimesheetTask.ProjectId,
        UserId: this.userDetail.SiteUserId,
        TaskTypeId: this.addTimeSheetData.TaskTypeId,
        TimeSpent: this.addTimeSheetData.TimeSpent,
        Comments: this.addTimeSheetData.Comments,
        TimeSheet_Date: this.addTimeSheetData.TimeSheet_Date,
        Created_By: this.userDetail.SiteUserId,
        TaskId: TimesheetTask.TaskId,
      };
      this.showLoader = true;
      this._httpService
        .ajaxPost("Timesheet/AddTimesheetWithTask", model)
        .subscribe(
          (data) => {
            var msg = data["Status"].Message.split("|");

            if (msg.length > 1) {
              msg[0] = msg[0].toLowerCase();
              this.CancelAddTimesheet();
              this._sharedService.ShowMessage(data["Status"].Message);
            } else {
              this._sharedService.ShowMessage(data["Status"].Message);
            }
          },
          (err) => {
            this.showLoader = false;
            this._sharedService.ShowMessage(this.constants.globalError);
          },
          () => {
            this.showLoader = false;
          },
        );
    }
  }

  validate(item) {
    var mandatory = "";
    var invalid = "";
    var functional = "";

    if (item.TimeSheet_Date == "" || item.TimeSheet_Date == null) {
      mandatory = mandatory + "<br>TimeSheetDate";
    }

    console.log("1", item.TimeSheet_Date);

    const selectedDate = moment(item.TimeSheet_Date, "DD/MM/YYYY");
    const today = moment().startOf("day");

    if (!selectedDate.isValid()) {
      mandatory += "<br>Invalid TimeSheetDate format";
    } else if (selectedDate.isAfter(today)) {
      mandatory += "<br>TimeSheetDate cannot be a future date";
    }

    if (item.TaskTypeId == "" || item.TaskTypeId == null) {
      mandatory = mandatory + "<br>TaskType";
    }

    if (item.TimeSpent == "" || item.TimeSpent == null) {
      mandatory = mandatory + "<br>ActualTime";
    } else {
      const timeSpent = parseInt(item.TimeSpent, 10);

      if (isNaN(timeSpent)) {
        mandatory += "<br>ActualTime must be a valid number (in minutes)";
      } else if (timeSpent < 0) {
        mandatory += "<br>ActualTime cannot be negative";
      } else if (timeSpent > 1440) {
        mandatory += "<br>ActualTime cannot exceed 1440 minutes (24 hours)";
      }
    }

    if (item.Comments == "" || item.Comments == null) {
      mandatory = mandatory + "<br>Comments";
    } else if (item.Comments.length > 2000) {
      mandatory =
        mandatory + "<br>Comments length should be less than 2000 charecter";
    }

    if (mandatory == "" && invalid == "" && functional == "") {
      return true;
    } else {
      var msg = "";
      if (mandatory != "") {
        msg = msg + "Please enter : " + mandatory;
        msg = msg + "<br>";
      }
      if (invalid != "") {
        msg = msg + "Please enter valid : " + invalid;
        msg = msg + "<br>";
      }
      if (functional != "") {
        msg = msg + functional;
      }
      this._sharedService.ShowMessage("error|" + msg);
    }
    return false;
  }
}



/** WEBPACK FOOTER **
 ** ./TypeScripts/MyTask/MyTask.component.ts
 **/